import { render, staticRenderFns } from "./selected-proposal.vue?vue&type=template&id=60beac9b"
import script from "./selected-proposal.vue?vue&type=script&lang=js"
export * from "./selected-proposal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports